import { gql } from "apollo-boost";

export const GET_INVENTORIES = gql`
  query Inventories($where: InventoryWhereInput, $limit: Int, $skip: Int, $orderBy: OrderByInput) {
    inventories(where: $where, limit: $limit, skip: $skip, orderBy: $orderBy) {
      status
      msg
      total
      err
      dataMany {
        id
        lot {
          survivalNumber
        }
        createdBy {
          firstName
        }
        category {
          name
        }
        unitId {
          name
        }
        brand {
          name
        }
        subbrand {
          name
        }
        price
        originPrice
        amountBefore
        amount
        amountSale
        amountAll
        volume
        volumeSale
        volumeAll
        shippingCost
        sort
        tag
        platform
        currency
        type
        form
        to
        size
        image
        name
        unit
        cfMessage
        categoryName
        unitName
        brandName
        subBrandName
        barCode
        mfg
        exp
        isDeleted
        createdAt
        updatedAt
      }
    }
  }
`;

// export const GET_INVENTORIES = gql`
//   query Query($where: InventoryWhereInput, $orderBy: OrderByInput, $skip: Int, $limit: Int) {
//   inventories(where: $where, orderBy: $orderBy, skip: $skip, limit: $limit)
// }
// `;

// export const GET_LOT_INVENTORIES = gql`
//   query LotInventories($where: InventoryWhereInput, $orderBy: OrderByInput, $skip: Int, $limit: Int) {
//     lotInventories(where: $where, orderBy: $orderBy, skip: $skip, limit: $limit)
//   }
// `;
export const GET_LOT_INVENTORIES = gql`
  query LotInventories($where: InventoryWhereInput, $orderBy: OrderByInput, $skip: Int, $limit: Int) {
    lotInventories(where: $where, orderBy: $orderBy, skip: $skip, limit: $limit) {
      status
      msg
      total
      err
      dataView {
        totalAmount
        totalVolume
        totalPrice
        averagePrice
        documentCount
        createdAt
        createdBy {
          firstName
        }
        tag
        type
        lot {
          survivalNumber
        }
        lotName
        date
        currency
        createdByName
      }
    }
  }
`;

export const GET_CURRENCY_INVENTORIES = gql`
  query CurrencyInventories($where: InventoryWhereInput, $orderBy: OrderByInput, $skip: Int, $limit: Int) {
    currencyInventories(where: $where, orderBy: $orderBy, skip: $skip, limit: $limit) {
      status
      msg
      total
      err
      dataView {
        totalAmount
        totalVolume
        totalPrice
        averagePrice
        documentCount
        createdAt
        createdBy {
          firstName
        }
        tag
        type
        lot {
          survivalNumber
        }
        lotName
        date
        currency
        createdByName
      }
    }
  }
`;

export const GET_SURVIVAL_LOTS = gql`
  query Survivals($where: SurvivalWhereInput) {
    survivals(where: $where) {
      total
      data {
        id
        survivalNumber
        status
        note
        isDeleted
        createdAt
        updatedAt
      }
    }
  }
`;
